import axios from '../localAxios';
import { teamsMembersURL } from './urls';

interface RemoveFromTeamParams {
  teamId: string;
  publicIds: string[];
}

export async function removeMembersFromTeam({
  teamId,
  publicIds,
}: RemoveFromTeamParams) {
  const url = teamsMembersURL(teamId);

  const response = await axios.delete<{ message: string }>(url.toString(), {
    data: { publicIds },
  });

  return response.data;
}
